function showDependsParams() {
  const inputsWithDepends = document.querySelectorAll('.show-depends');
  inputsWithDepends?.forEach(function (elem) {
    elem.addEventListener('change', function (e) {
      const inputWithDepends = e.currentTarget;
      const inputWithDependsId = inputWithDepends.name;
      const needDisable = inputWithDepends.getAttribute('data-need-disable');
      const parentBlockClass = inputWithDepends.getAttribute('data-parent-class');
      const parentBlock = inputWithDepends.closest('.' + parentBlockClass);
      const dependencies = parentBlock.querySelectorAll('[data-depends-on="' + inputWithDependsId + '"]');

      dependencies?.forEach(function (paramBlock) {
        const paramInputs = paramBlock.querySelectorAll('input');

        if (inputWithDepends.checked) {
          paramBlock.classList.remove('d-none');
        } else {
          paramBlock.classList.add('d-none');
        }

        if (needDisable) {
          paramInputs?.forEach(function (paramInput) {
            paramInput.disabled = !inputWithDepends.checked ? true : false;
          });
        }
      });
    });
  });
}

export {showDependsParams};